import { DataAgg, SortDir } from '../meta/basetype';

/**
 * å¨æ¥è¯¢æ¡ä»¶ä¸­ï¼æå®æä¸ªå¼æ¯nullï¼å ä¸ºèªç¶çnullå¨åå°å°è¢«è§£æä¸ºç©ºæ¡ä»¶ï¼å°è¢«å¿½ç¥ï¼
 */
export const NULLVALUE = '$$__null__$$';
/**
 * å¨æ¥è¯¢æ¡ä»¶ä¸­ï¼æå®æä¸ªå¼æ¯not null
 */
export const NOTNULLVALUE = '$$__notnull__$$';

/** å¨æ°å¢å®ä½æ¯ï¼ååå°è·ååå§åå®ä½çæ¶åä½¿ç¨çID */
export const NEWENTITYID = '-1';

export interface AggDataItem {
  [agg: string]: any;
}

export interface AggData {
  [fieldName: string]: AggDataItem;
}

export interface QueryAgg {
  field: string;
  aggregate: DataAgg; // sum min max count average
}

export interface QueryColumn {
  propName?: string;
  field?: string;
  agg?: DataAgg; // sum,average,cont,min,max
}

export interface QuerySort {
  field: string;
  dir?: SortDir; // asc desc,default: asc
}

/**
 * æ¥è¯¢æ¡ä»¶
 *
 * å±æ§åç§°ä»£è¡¨æ¥è¯¢çå­æ®µæèå±æ§åç§°ï¼æ¯æåµå¥è¡¨è¾¾ï¼ãæå¦ä¸ç¹æ®è¡¨è¾¾æ¹å¼ï¼
 *
 * 1 *(prop1,prop2...) : è¡¨å¯¹æ¬å·éé¢çå±æ§è¿è¡æ¨¡ç³å¹éå¹¶ç¨ãæãè¿è¡è¿æ¥ï¼
 *
 * 2 ** : å¨ææ¨¡ç³å¹é
 *
 * 3 *** : å¨ææ¨¡ç³ï¼åè¯ï¼å¹é
 *
 * å±æ§å¼è¡¨ç¤ºæ¯è¾çå¼ãæå¦ä¸è¡¨ç¤ºæ¹æ³ï¼
 *
 * 1 <val1> <val2> : å½å¤ä¸ªå­ä»¥ç©ºæ ¼åéçæ¶åï¼è¡¨ç¤ºå¯¹å¤ä¸ªå¼è¿è¡å¤æ¬¡å¹éï¼andï¼ï¼
 *
 * 2 [val1,val2]
 */
export interface QueryParams {
  [param: string]: any;
}
/**
 * ååå°æäº¤éç¨æ¥è¯¢çå°è£æ ¼å¼
 */
export interface RestQuery {
  /**
   * åé¡µå¼å§è¡
   */
  first?: number;
   /**
   * åé¡µçé¡µé¢å¤§å°ï¼æ¡æ°ï¼ï¼å¦æå°äºç­äº0è¡¨ç¤ºä¸åé¡µ
   */
  rows?: number;
  orderBy?: string; // ex: 'custname desc,custno asc'
  limit?: number;
  aggregate?: QueryAgg[];
  /**
   * æåºè®¾ç½®
   */
  sort?: QuerySort[];
  /**
   * æ¥è¯¢æ¡ä»¶
   */
  search?: QueryParams;
  /**
   * æ¥è¯¢å±æ§åå®ä¹ï¼å¦æä¸ºç©ºï¼è¡¨ç¤ºè¿åææå±æ§
   */
  columns?: QueryColumn[] | string;
}

/**
 * åå°è¿åçé¡µé¢æ°æ®
 */
export interface PageData<T> {
  /**
   * åé¡µå¼å§è¡
   */
  first: number;
  /**
   * åé¡µçé¡µé¢å¤§å°ï¼æ¡æ°ï¼
   */
  rows: number;
  /**
   * è¿åçæ°æ®åè¡¨
   */
  datas: T[];
  /**
   * æ»çæ°æ®æ¡æ°
   */
  total: number;
  /**
   * æ±æ»æ°æ®
   */
  aggregates?: AggData;
}

/**
 * è½¬æ¢æåºè¡¨è¾¾å¼å°æåºè®¾ç½®æ°ç»
 * @param orderBy æåºè¡¨è¾¾å¼ï¼
 * <propName> [asc|desc],<propName> [asc|desc],
 * Ex: deptname desc
 * å¤ä¸ªæåºå±æ§ç¨éå·éå¼ï¼å¦ææªæå®ååºæèéåºï¼åé»è®¤ä¸ºååºã
 * @returns è¥ä¼ å¥ç©ºå­ç¬¦ä¸²æènullåè¿å[]
 */
export function orderByToSorts(orderBy: string): QuerySort[] {
  if (!orderBy) {
    return [];
  }

  return orderBy.split(',')
    .filter(it => !!it)
    .map(it => it.split(/\s+/))
    .map(kk => ({
      field: kk[0].trim(),
      dir: kk.length > 1 && kk[1].trim() === SortDir.desc
        ? SortDir.desc : SortDir.asc
    }));
}

